module.exports = __webpack_public_path__ + "b37358a1a76ab385e4ea28f3732b7f57.svg";